import { useParams } from "react-router-dom";
import Menu from "../components/Common/Menu";
import Accordion from "../components/Common/Accordion";
import Footer from "../components/Common/Footer";
import { trassir, Item } from "../utils/trassir";

function Details() {
  const { id } = useParams();

  // Find the item by id
  const item: Item | undefined = trassir.find((i) => i.id === id);

  if (!item) return <p>Item not found</p>;

  return (
    <div>
      <Menu />

      <Accordion
        title={item.title}
        description={item.description}
        vector={item.vector}
        data={item.details}
      />

      <Footer />
    </div>
  );
}
export default Details;
